export const PointShopTypeConst = {
  AVAILABLE_COUNT: "availablecount",
  UNLIMITED: "unlimited",
  DATE_RANGE: "daterange",
};
